import { useState, useEffect } from "react";
import { useLanguage } from "@/LanguageContext";
import { t } from "@/translations";

const COOKIE_KEY = "vallarta_pixel_cookie_consent";

const CookieBanner = () => {
  const { lang } = useLanguage();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem(COOKIE_KEY);
    if (!accepted) setShow(true);
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, "true");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="cookie-banner" data-testid="cookie-banner">
      <p className="cookie-text">
        <strong>{t("cookie.text", lang)}</strong>{" "}
        {t("cookie.love", lang)}
      </p>
      <button onClick={accept} className="cookie-btn" data-testid="cookie-accept-btn">
        {t("cookie.accept", lang)}
      </button>
    </div>
  );
};

export default CookieBanner;
